function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.51 14.81"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.03 2.01l-3.6-.96C14.09.43 13.44.01 12.68.01H6.92c-.74 0-1.39.41-1.73 1.02l-3.71.99C.42 2.3-.22 3.39.07 4.46l2.37 8.87c.24.89 1.05 1.48 1.93 1.48.17 0 .34-.02.52-.07l4.86-1.3 4.86 1.3c.17.05.35.07.52.07.88 0 1.69-.59 1.93-1.48l2.38-8.87c.29-1.06-.35-2.16-1.41-2.45zm-5.35 0v9.17h-.75c0-.13-.03-.25-.06-.38L9.52 2h3.17zm-8.3 10.8L2 3.94l2.92-.78 2-.54.65-.17 2.38 8.87-5.57 1.49zm10.76 0l-1-.27a2 2 0 00.54-1.36v-8l2.83.76-2.38 8.87z",
  fill: "#12002d"
})));